import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaAction, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { ActionTypes } from "../../../../enums/ActionTypes";
import { ActionStyles } from "../../../../enums/ActionStyles";
import editIcon from "../../../../assets/icons/icon-pen-white.svg"
import { NotEmptyString, NumberGreaterThanZero, ValidateInt } from "../../../../Validation/Validation";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../modules/auth/Permissions/PermissionStrings";
import SidePanelSpecimens from "../../layout/SidePanel/layouts/SidePanelSpecimens";

export const SpecimenSchema: ISchema = {
    displayName: "Part Cases",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelSpecimens data={data} showHeader={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'specimenCode',
            displayName: 'Specimen Number',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Code cannot be empty",
        } as ISchemaProperty,
        {
            name: 'caseId',
            displayName: 'Case',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'caseCode',
            displayName: 'Case Number',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'year',
            displayName: 'Year',
            type: PropertyTypes.year,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'type',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'quantity',
            displayName: 'Quantity',
            type: PropertyTypes.quantity,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: ValidateInt as Function,
            validationError: "Please enter a quantity",
            defaultDisplayValue: "Unknown"
        } as ISchemaProperty
    ],

    children: [
        { entityName: EntityNames.audits, displayName: "Audit Trail", cantView: true, viewType: EntityViewTypes.list } as ISchemaChild
    ],

    primaryFilter: {
        PropertyName: "Case.Code",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.code,
        placeHolder: "Enter a case number"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "SpecimenCode",
            displayName: "Specimen Number",
            type: FilterTypes.search,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.string,
            showInTab: true
        } as ISchemaFilter,
        {
            PropertyName: "Case.AccountId",
            entityName: "accounts",
            displayName: "Account",
            type: FilterTypes.select,
            required: true,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid
        } as ISchemaFilter,
        {
            PropertyName: "Case.Year",
            displayName: "Year",
            type: FilterTypes.year,
            required: true,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterial.CaseMaterialTypeId",
            entityName: "caseMaterialTypes",
            displayName: "Case Material Types",
            type: FilterTypes.multiSelect,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Contains,
            propertyType: PropertyTypes.guidList
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterial.Status",
            entityName: "caseMaterialStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int
        } as ISchemaFilter,
        {
            PropertyName: "Notes",
            displayName: "Notes",
            type: FilterTypes.search,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.FreeText,
            propertyType: PropertyTypes.string,
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Inventory_Search_Notes)),
        } as ISchemaFilter,
    ],

    sidePanelActions: [
        { text: "Edit Details", action: ActionTypes.edit, style: ActionStyles.primary, icon: editIcon } as ISchemaAction,
    ]
}
